import React, { useEffect, useState } from 'react'
import ToggleSwitch from '../../ReusableComponents/ToggleSwitch/ToggleSwitch'
import { colorShareState } from './detectors/colorDetector'
import styles from './Vision.module.css'

// Only surface colours that fill at least this much of the frame as a bar.
const MIN_SHARE = 0.02

// Sidebar for play-mode Colour detection: live bars showing the overall colour
// composition of the scene (Red 42%, Blue 21%, …), each bar auto-adjusting to
// whatever the camera currently sees.
const ColorOptions = () => {
    const [shares, setShares] = useState([])
    const [avgHex, setAvgHex] = useState('#000000')
    const [avgRgb, setAvgRgb] = useState([0, 0, 0])
    const [copied, setCopied] = useState(false)
    const [aim, setAim] = useState(colorShareState.aim)

    useEffect(() => {
        const t = setInterval(() => {
            setShares(colorShareState.shares.slice(0, 8))
            setAvgHex(colorShareState.averageHex)
            setAvgRgb(colorShareState.averageRgb)
        }, 200)
        return () => clearInterval(t)
    }, [])

    const copyHex = async () => {
        try {
            await navigator.clipboard.writeText(avgHex)
            setCopied(true)
            setTimeout(() => setCopied(false), 1200)
        } catch {
            /* clipboard may be unavailable; the hex is still shown to copy */
        }
    }

    const onAim = (on) => {
        colorShareState.aim = on
        setAim(on)
    }

    const shown = shares.filter((s) => s.share >= MIN_SHARE)

    return (
        <div className={styles.trackOptions}>
            <div className={styles.trackOptToggleRow}>
                <span className={styles.trackOptLabel}>Aim at a spot</span>
                <ToggleSwitch
                    size="md"
                    tone="orange"
                    checked={aim}
                    onChange={onAim}
                    ariaLabel="Aim at a spot"
                />
            </div>
            {aim && (
                <span className={styles.trackLineHint}>
                    Drag the box on the video onto the object you want to read.
                </span>
            )}

            <span className={styles.trackOptLabel}>Average colour</span>
            <div className={styles.colorAvgRow}>
                <span
                    className={styles.colorAvgSwatch}
                    style={{ background: `rgb(${avgRgb.join(',')})` }}
                />
                <span className={styles.colorAvgHex}>{avgHex}</span>
                <button
                    type="button"
                    className={styles.colorCopyBtn}
                    onClick={copyHex}
                >
                    {copied ? 'Copied' : 'Copy'}
                </button>
            </div>
            <span className={styles.trackLineHint}>
                Point at an object to read its colour, then paste this hex into a
                colour decision rule.
            </span>

            <span className={styles.trackOptLabel}>Colour composition</span>
            {shown.length === 0 ? (
                <span className={styles.trackLineHint}>
                    Point the camera at the scene — the bars show how much of
                    each colour is on screen.
                </span>
            ) : (
                <div className={styles.colorBars}>
                    {shown.map((s) => {
                        const pct = Math.round(s.share * 100)
                        return (
                            <div key={s.name} className={styles.colorBarRow}>
                                <span className={styles.colorBarName}>
                                    <span
                                        className={styles.colorBarChip}
                                        style={{ background: s.hex }}
                                    />
                                    {s.name}
                                </span>
                                <div className={styles.colorBarTrack}>
                                    <div
                                        className={styles.colorBarFill}
                                        style={{
                                            width: `${pct}%`,
                                            background: s.hex,
                                        }}
                                    />
                                </div>
                                <span className={styles.colorBarPct}>{pct}%</span>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default ColorOptions
